<template v-if="portalId">
  <portal :to="portalId">
    <slot />
  </portal>
</template>

<script>
export default {
  name: 'SduiPortalTo',
  computed: {
    portalId() {
      // try to find the component with data "portalId" to determine the correct "portal :to"
      // each portal must have a unique name

      // abort if it takes more than 10 levels up the DOM
      const max = 10
      let currParent = null
      for (let i = 0; i < max; i++) {
        currParent = currParent ? currParent.$parent : this.$parent
        if (currParent?.portalId) {
          break
        }
      }
      return currParent?.portalId
    },
  },
}
</script>
